/**
 * Default / fallback imagery for public blog pages.
 * Uses the brass ammo (bullet) pile asset until posts have dedicated covers.
 */

export const DEFAULT_BLOG_IMAGE = '/files/background.png';

/** Resolve a post cover: explicit fields first, then the default bullet image. */
export function getBlogCoverImage(post) {
  return (
    post?.coverImage ||
    post?.image ||
    post?.featuredImage ||
    post?.ogImage ||
    DEFAULT_BLOG_IMAGE
  );
}
